import React from "react";

type ContextType = {
  userData: any,
  company: any,
  editing: boolean,
  dialogOpen: boolean,
  refresh: any,
  update: any,
  setEditing: any,
  setDialogOpen: any,
  onCloseDialog: any,
  formValues: any
  
}
export default React.createContext<ContextType>({
  userData: {},
  company: {},
  editing: false,
  dialogOpen: false,
  refresh: null,
  update: null,
  setEditing: null,
  setDialogOpen: null,
  onCloseDialog: null,
  formValues: null
})